import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Employer } from '../../models/employer';
import { RenewalEmploymentInfo } from '../../models/renewal-employment-info';
import { EmploymentStatus } from '../../models/employmentstatus';
import { RenewalContactInfo } from '../../models/renewal-contact-info';
import { IncomeInfo } from '../../models/incomeinfo';
import { AdditionalIncome } from '../../models/additionalincome';
import { Industry } from '../../models/industry';
import { RenewalPrimaryEmployerService } from '../../../services/renewal-primary-employercog.service';
import { ApplicationDataService } from '../../../services/application.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ErrorService } from '../../../services/error.service'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TwoYearsEmpDialogComponent } from '../../application/employment/two-years-emp-dialog/two-years-emp-dialog.component';
import { TelephoneNumber } from 'app/models/telephone-number';
import { LabelValue } from 'app/models/labelvalue';

@Component({
  selector: 'app-primary-renewal-employment-cog',
  templateUrl: './primary-renewal-employment-cog.component.html',
  styleUrls: ['./primary-renewal-employment-cog.component.css'],
})
export class PrimaryRenewalEmploymentComponent implements OnInit {
  @ViewChild('employmentInfo', { static: true }) private myScrollContainer: ElementRef;
  RentalApplicantKey: number;
  model: RenewalEmploymentInfo;
  RentalApplicationKey: number;
  employments: Employer[] = [];
  employmentStatus: LabelValue[];
  additionalIncome: AdditionalIncome = new AdditionalIncome();
  errorMessage: string;
  industries: LabelValue[];
  displayValidationMsg = false;
  autoCompleteSettings: any = {
    showSearchButton: false,
    showRecentSearch: false,
    geoTypes: ['establishment'],
    geoCountryRestriction: ['us'],
    inputPlaceholderText: 'Employer Name'
  };
  AddAdditionalApplicantKey: number = null;
  AddAdditionalApplicantName: string = null;
  CompletedByOther: boolean = false;

  @ViewChild('employmentForm', { static: true })
  employmentForm: NgForm;

  constructor(
    private employmentService: RenewalPrimaryEmployerService,
    private applicationService: ApplicationDataService,
    public router: Router, public route: ActivatedRoute,
    public dialog: MatDialog
  ) {
    this.industries = [];

    this.model = new RenewalEmploymentInfo();

    const RenewalKey = localStorage.getItem('RenewalKey');

    if (RenewalKey !== undefined && RenewalKey !== null) {

      this.model.LeaseRenewalKey = Number(localStorage.getItem('RenewalKey'));

      this.employmentService.getEmploymentInformation(this.model)
        .subscribe(res => this.onGetEmploymentSuccess(res), res => this.employmentService.handleError(res));

      this.applicationService.getEmploymentStatuses().subscribe(res => this.getEmploymentStatus(res),
        res => this.applicationService.handleError(res))
    }
  }

  ngOnInit() {
    this.applicationService.getRentalIndustries()
      .subscribe(res => this.onGetIndustriesSuccess(res), err => this.applicationService.handleError(err));
  }

  onDateBlur(event) {
    this.employmentForm.controls[event.target.id].updateValueAndValidity({ emitEvent: false });
  }

  ngAfterViewChecked() {
    // this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollIntoView(false);
    } catch (err) { console.log('error: ' + err); }
  }

  getEmploymentStatus(statuses: EmploymentStatus[]) {
    this.employmentStatus = [];
    for (const status of statuses) {
      this.employmentStatus.push({ label: status.Title, value: status.EmploymentStatusKey });
    }
  }

  checkEmploymentHistory() {
    let diffDays = 0;
    if (this.employments.length > 0) {

      let employmentsForSorting = this.employments.map(x => Object.assign({}, x));

      employmentsForSorting.sort(function (a, b) {
        return new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime();
      });
      const StartDate = employmentsForSorting[0].StartDate;
      let EndDate = employmentsForSorting[employmentsForSorting.length - 1].EndDate;
      if (EndDate === null) {
        EndDate = new Date();
      }
      const timeDiff = Math.abs(StartDate.getTime() - EndDate.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    if ((diffDays / 365) < 2) {
      this.displayValidationMsg = true;
    } else {
      this.onSubmit();
    }
  }

  twoYears() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "300px";
    let dialogRef = this.dialog.open(TwoYearsEmpDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result == "yes") {
        this.onCloseWarning();
      }
      else if (result == "no") {
        this.onSubmit();
      }
    });
  }

  cancelEdit() {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.router.navigate(['/application/applicants']);
  }

  onSubmit() {
    this.model.Employments = [];
    //copying arrays from model.Employments to employments
    //need to do this way or new array will point to old array.
    this.employments.forEach(val => this.model.Employments.push(Object.assign({}, val)));

    if (this.model.Employments.length > 0) {
      for (const emp of this.model.Employments) {
        emp.IsCurrnet = false;
        emp.Phone = emp.PhoneNumber.format();
        emp.SupervisorPhone = emp.SupervisorPhoneNumber.format();
      }
      this.model.Employments[this.model.Employments.length - 1].IsCurrnet = true;
    }

    this.employmentService.updateEmploymentInformation(this.model)
      .subscribe(res => this.onUpdateSuccess(res), res => this.employmentService.handleError(res));
  }

  onCloseWarning() {
    this.displayValidationMsg = false;
    this.onAddEmployerClick();
  }

  onUpdateSuccess(income: RenewalEmploymentInfo) {
    this.router.navigate(['/renewalcog/renewal-review/choose-plan']);
  }

  async onGetEmploymentSuccess(income: RenewalEmploymentInfo) {
    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.CompletedByOther = true;
    }
    else {
      this.CompletedByOther = false;
    }

    for (const emp of income.Employments) {
      emp.StartDate = new Date(emp.StartDate);
      if (emp.EndDate != null) {
        emp.EndDate = new Date(emp.EndDate);
      }
      if (emp.Phone) {
        const phoneTemp = emp.Phone.replace(/[^A-Z0-9]/ig, "");
        emp.PhoneNumber = new TelephoneNumber(phoneTemp.substr(0, 3), phoneTemp.substr(3, 3), phoneTemp.substr(6, 4));
      }
      if (emp.SupervisorPhone) {
        const supervisorPhoneTemp = emp.SupervisorPhone.replace(/[^A-Z0-9]/ig, "");
        emp.SupervisorPhoneNumber = new TelephoneNumber(supervisorPhoneTemp.substr(0, 3), supervisorPhoneTemp.substr(3, 3), supervisorPhoneTemp.substr(6, 4));
      }
    }
    //make sure the current employment goes first
    for (var i = 0; i < income.Employments.length; i++) {
      if (income.Employments[i].IsCurrnet == true) {
        var element = income.Employments.splice(i, 1);   // removes the item
        income.Employments.unshift(element[0]);         // adds it back to the beginning
        break;
      }
    }
    this.employments = income.Employments;

    if (this.employments.length === 0) {
      this.employments = [];
      this.employments.push(new Employer());
    }
  }

  onGetIndustriesSuccess(industries: Industry[]) {
    this.industries = [];
    for (const industry of industries) {
      this.industries.push({ label: industry.Title, value: industry.RentalIndustryKey });
    }
  }

  onAddEmployerClick() {
    if (!this.employments) {
      this.employments = [];
    }
    this.employments.push(new Employer());
  }

  onRemoveEmployerClick(employment: Employer) {
    const index = this.employments.indexOf(employment);
    this.employments.splice(index, 1);

    let i = 0;
  }

  autoCompleteCallback1(selectedData: any, data: any) {
    if (selectedData.name !== undefined) {
      this.employments[data].EmployerName = selectedData.name;
      this.employments[data].Phone = selectedData.formatted_phone_number;
      this.employments[data].Address = selectedData.formatted_address;
    }
    else {
      this.employments[data].EmployerName = selectedData;
    }
  }

  initAutoCompleteSettings(data: any, initialValue: any) {
    this.autoCompleteSettings.name = data;
    this.autoCompleteSettings.id = data;
    this.autoCompleteSettings.inputString = initialValue;
    return this.autoCompleteSettings;
  }

  // Do Not Delete.  ngFor will break on add remove without.
  listTrack(o) {
    return o;
  }
}
